import { Router } from '@angular/router';
import { Component, OnInit, Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Output() toogleSideBarForMe:EventEmitter<any>=new EventEmitter();
  name:any;user:any;email:any;first:any;
  constructor(private route:Router) {
    this.user=JSON.parse(localStorage.getItem('username'))
    console.log(this.user)
    
   }
  toogleSideBar()
  {
    this.toogleSideBarForMe.emit();
    setTimeout(() => {
      window.dispatchEvent(
        new Event('resize')
      );
    }, 300);
  }
  profile()
  {
    this.route.navigateByUrl('/dashboard/Profile');
  }
  change()
  {
    this.route.navigateByUrl('/dashboard/ChangeUserPassword');
  }
  logOut()
  {
    localStorage.removeItem('token');
    this.route.navigateByUrl('');
  }
  ngOnInit(): void {
  }
  

}
